import { createTheme } from '@mui/material/styles';

const ELECTRIC_PURPLE = '#7B2FF7';
const ELECTRIC_PURPLE_DARK = '#6420D0';
const INK = '#0a0a0b';

const glassBackground = 'rgba(24, 24, 30, 0.6)';
const glassBorder = '1px solid rgba(255, 255, 255, 0.08)';

const appBackgroundGradient = `
    radial-gradient(1100px circle at 12% -8%, rgba(0,194,255,0.18), transparent 45%),
    radial-gradient(900px circle at 88% 15%, rgba(123,47,247,0.16), transparent 50%),
    radial-gradient(800px circle at 50% 90%, rgba(123,47,247,0.10), transparent 55%),
    linear-gradient(180deg, #0a0a0b 0%, #101012 45%, #0a0a0b 100%)
`;

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: ELECTRIC_PURPLE, dark: ELECTRIC_PURPLE_DARK, contrastText: '#ffffff' },
        secondary: { main: '#ffffff', dark: '#e0e0e0', contrastText: INK },
        error: { main: '#ef4444' },
        background: {
            default: '#0a0a0d',
            paper: glassBackground,
        },
        text: {
            primary: '#f5f5f7',
            secondary: 'rgba(245, 245, 247, 0.64)',
        },
        divider: 'rgba(255, 255, 255, 0.08)',
    },
    shape: { borderRadius: 18 },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h6: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    minHeight: '100vh',
                    background: appBackgroundGradient,
                    backgroundColor: '#0a0a0d',
                    backgroundAttachment: 'fixed',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: glassBackground,
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    border: glassBorder,
                    boxShadow: '0 4px 24px rgba(10, 10, 11, 0.06)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'rgba(10, 10, 11, 0.85)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    border: 'none',
                    boxShadow: '-12px 0 40px rgba(0, 0, 0, 0.45)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(10, 10, 11, 0.75)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
                    color: '#ffffff',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 999, paddingLeft: 18, paddingRight: 18 },
                outlined: { borderColor: 'rgba(255, 255, 255, 0.24)' },
                contained: { boxShadow: 'none' },
                containedPrimary: {
                    backgroundColor: ELECTRIC_PURPLE,
                    color: '#ffffff',
                    boxShadow: '0 6px 6px rgba(100,32,208,0.35), 0 16px 36px rgba(123,47,247,0.3)',
                    transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.2s ease',
                    '&:hover': {
                        backgroundColor: ELECTRIC_PURPLE,
                        boxShadow: '0 9px 10px rgba(100,32,208,0.4), 0 22px 46px rgba(123,47,247,0.38)',
                        transform: 'translateY(-3px)',
                    },
                    '&:active': {
                        boxShadow: '0 2px 5px rgba(100,32,208,0.32), 0 6px 18px rgba(123,47,247,0.25)',
                        transform: 'translateY(4px)',
                    },
                },
                containedSecondary: {
                    backgroundColor: '#ffffff',
                    color: INK,
                    '&:hover': { backgroundColor: '#e0e0e0', boxShadow: 'none' },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 600 },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.06)',
                    borderRadius: 10,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                },
            },
        },
    },
});

export default theme;
